const TZ = "Asia/Dubai";

export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-GB", {
        timeZone: TZ,
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

export const fmtTime = (iso) =>
  iso
    ? new Date(iso).toLocaleTimeString("en-GB", {
        timeZone: TZ,
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-GB", { timeZone: TZ }) : "";
